import type { EnvironmentProviders } from '@angular/core';
import { makeEnvironmentProviders } from '@angular/core';
import { CONFIG } from '@config';

import { REWARDS_CONTENT_CONFIG } from './config.token';
import { LayoutSource } from './layout-source';
import { RewardsContentLayoutSource } from './rewards-content-layout-source';

export const provideRewardsContent = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: REWARDS_CONTENT_CONFIG,
      useValue: CONFIG.rewardsContent,
    },
    {
      provide: LayoutSource,
      useExisting: RewardsContentLayoutSource,
    },
  ]);
